import { render, staticRenderFns } from "./SearchStyled.vue?vue&type=template&id=579b4bed&scoped=true"
import script from "./SearchStyled.vue?vue&type=script&lang=js"
export * from "./SearchStyled.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "579b4bed",
  null
  
)

export default component.exports